export enum ESocialType {
  Tg = 'tg',
  Pulse = 'pulse',
  Ir = 'ir-cian',
}

export type TSocial = {
  id: ESocialType;
  url: string;
  text?: string;
};
